"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PasswordTooltip = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _PasswordTooltip = require("./PasswordTooltip.styled");
var _UserValidator = require("../../validators/UserValidator/UserValidator");
var PasswordTooltip = exports.PasswordTooltip = function PasswordTooltip(props) {
  var _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'top' : _props$placement,
    _props$password = props.password,
    password = _props$password === void 0 ? '' : _props$password,
    _props$targetElement = props.targetElement,
    targetElement = _props$targetElement === void 0 ? '' : _props$targetElement;
  if (!password || password === '') return null;
  var validation = _UserValidator.UserValidator.getPasswordTooltipValidation(password || '');
  var validationNodes = validation.map(function (_ref, index) {
    var valid = _ref.valid,
      message = _ref.message;
    var iconName = valid ? _freeSolidSvgIcons.faCheck : _freeSolidSvgIcons.faTimes;
    var iconColor = valid ? 'green' : 'red';
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: "validator-".concat(index)
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "icon-spacer"
    }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: iconName,
      style: {
        color: iconColor
      }
    })), message);
  });
  return /*#__PURE__*/_react["default"].createElement(_PasswordTooltip.StyledTooltip, {
    isOpen: true,
    placement: placement,
    target: targetElement,
    className: "in password-tooltip",
    id: "password-tooltip"
  }, "Passwords must contain:", validationNodes);
};
PasswordTooltip.propTypes = {
  placement: _propTypes["default"].string,
  password: _propTypes["default"].string,
  targetElement: _propTypes["default"].string
};
var _default = exports["default"] = PasswordTooltip;